// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f","930":"164f4fb6"}[chunkId] || chunkId) + "." + {"195":"bc0c6a61c1fb0417","199":"1103c9b19ee071f5","316":"2cf0d2625664d51a","501":"7e63d871e474c3ee","930":"d7d47e9ede08796f","966":"d79987feb5d0c389"}[chunkId] + ".js";
};